const fetch = require('isomorphic-fetch');

const cache: any = {};

function getFromCacheOrRemote(key: string, url: string, method: any, data = null): Promise<any> {
    const methodArgs = [url, data];
    if (cache[key]) {
        return new Promise(resolve => resolve(cache[key]));
    } else {
        //@ts-ignore
        return method.apply(this, methodArgs).then(resp => {
            cache[key] = resp;
            return resp;
        });
    }
}

function fetchpost(url: string, payload: {}): Promise<any> {
    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then((response: Response) => {
            if (response.ok) {
                return response.text().then(text => (text ? JSON.parse(text) : null));
            } else if (response.status === 404) {
                throw new Error('Not found response from server');
            } else {
                throw new Error('Bad response from server');
            }
        })
        .catch((error: Error) => {
            throw error;
        });
}

export function fetchgetraw(
    url: string,
): Promise<{ body: string; headers: any; statusCode: number }> {
    return fetch(url, {
        method: 'GET',
        mode: 'cors',
    })
        .then(async (response: Response) => {
            if (response.ok) {
                const body = await response.text();
                return {
                    body,
                    headers: (response.headers as any)._headers, // This hack is due to the nature of the Header object polyfill
                    statusCode: response.status,
                };
            } else if (response.status === 404) {
                throw new Error('Not found response from server');
            } else {
                throw new Error('Bad response from server');
            }
        })
        .catch((error: Error) => {
            throw error;
        });
}

export function fetchget(url: string): Promise<any> {
    return fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
        },
    })
        .then((response: Response) => {
            if (response.ok) {
                return response.json();
            } else if (response.status === 404) {
                throw new Error('Not found response from server');
            } else {
                throw new Error('Bad response from sever');
            }
        })
        .catch((error: Error) => {
            throw error;
        });
}

export function get(url: string, isCached = false): Promise<any> {
    const key = `get:${url}`;
    if (isCached) {
        return getFromCacheOrRemote(key, url, fetchget);
    }
    return fetchget(url);
}

export function post(url: string, data: any, isCached = false): Promise<any> {
    const key = `post:${url}:${JSON.stringify(data)}`;
    if (isCached) {
        return getFromCacheOrRemote(key, url, fetchpost, data);
    }
    return fetchpost(url, data);
}
